import VideoThumbnail from '@repo/ui/src/components/VideoThumbnail';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { LinkProps, MediaType, YoutubeLinkProps } from '@repo/ui/src/types';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';

interface Props {
  title?: string;
  description?: string;
  uploadedThumbnail?: MediaType[];
  link?: {
    link: LinkProps;
  };
  asset?: MediaType;
  name?: string;
  duration?: string;
  youtubeLink?: YoutubeLinkProps;
  thumbnailUrl?: string;
  darkMode?: boolean;
  onClick?: () => void;
}

const PlaylistCard = ({
  title,
  description,
  uploadedThumbnail,
  link,
  asset,
  name,
  duration,
  youtubeLink,
  thumbnailUrl,
  darkMode,
  onClick,
}: Props) => {
  const videoTitle = name || title;
  const thumbnail =
    asset ||
    (uploadedThumbnail
      ? uploadedThumbnail[0]
      : youtubeLink?.uploadedThumbnail
        ? youtubeLink.uploadedThumbnail[0]
        : null);
  const builtThumbnailUrl = thumbnail
    ? buildImageSrc(thumbnail, 500, 2, 1)
    : 'https://i8.amplience.net/i/traeger/black-image/?w=500&h=300&sm=c&scaleFit=poi&$poi2$';
  const cardImage = thumbnailUrl || builtThumbnailUrl || youtubeLink?.thumbnailUrl;

  return (
    <div
      className={classNames(
        'flex flex-col h-full',
        darkMode ? 'bg-neutral-700 text-white' : 'bg-white text-neutral-700',
      )}
    >
      <div className="h-full pb-6">
        <VideoThumbnail
          title={title}
          imgUrl={cardImage}
          duration={duration || youtubeLink?.duration}
          onClick={onClick}
        />
        {videoTitle && <h6 className="tra-text-web-heading-6 m-6">{videoTitle}</h6>}
        {description && (
          <div className="hidden sm:block">
            <hr className="border-2 w-6 border-brand-300 ml-6" />
            <p
              className={classNames(
                darkMode && 'text-white',
                'tra-text-web-body-l pt-4 px-6 line-clamp-4',
              )}
            >
              {description}
            </p>
          </div>
        )}
      </div>
      {(link?.link?.link || link?.link?.externalLink) && (
        <div className="p-6">
          <Button
            as={Anchor}
            {...link.link}
            variant={ButtonVariant.knife}
            dark={darkMode}
            dataTestId="playlist-card-link-button"
          >
            {link.link.displayName}
          </Button>
        </div>
      )}
    </div>
  );
};

export default PlaylistCard;
